var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import clsx from 'clsx';
import { XR } from '../index';
import { preventClick } from '../../util/preventClick';
import { useDevice } from '../hook/useDevice';
export function LayoutSidebar(input) {
    var id = input.id, _a = input.visible, visible = _a === void 0 ? 'auto' : _a, _b = input.width, width = _b === void 0 ? 240 : _b, children = input.children, initialOpen = input.initialOpen, className = input.className, rest = __rest(input, ["id", "visible", "width", "children", "initialOpen", "className"]);
    var sidebar = XR.useLayout().sidebar;
    var device = useDevice();
    sidebar.useRegister({ id: id, visible: visible, width: width });
    useEffect(function () {
        if (initialOpen) {
            sidebar.toggleOpen(id);
        }
    }, []);
    var style = {
        width: width,
        transform: sidebar.isOpen(id) ? '' : "translateX(" + -width + "px)",
    };
    return (React.createElement(React.Fragment, null,
        device.isTouch && (React.createElement("div", { className: clsx('XR-LayoutSidebar-overlay', { isOpen: sidebar.isOpen(id) }), onClick: function () { return sidebar.toggleOpen(id); } })),
        React.createElement(XR.Box, __assign({ className: clsx(className, 'XR-LayoutSidebar', { isOpen: sidebar.isOpen(id) }, visible), onClick: preventClick, style: style }, rest), children)));
}
